// extracted by mini-css-extract-plugin
module.exports = {"text":"captionSkins-noMargin-text-6c595ae7"};